function print() {
    setTimeout(function () {
        $("div.cart_full").each(function (index2, element2) {
            $(element2).find("page:eq(0)").prepend($(element2).find(".header_first").html());
        });

        var page_attr = getAttr("page:eq(0)");
        console.log(page_attr);

        var cart_attr = getAttr("div.cart-one:eq(0)");
        console.log(cart_attr);

        var page_height = $("page").height();
        console.log("page height", page_height);
        var cur_height = 0;
        $("#toggle-math").click(function () {
            $("div.question").each(function (index, element) {
                var tmp = $(element).html();
                $(element).html(tmp);
            });

            $(this).hide();
            $("div.cart_full").each(function (index2, element2) {
                cur_height = 0;
                var cur_page = 1;
                var first_page = true;
                $(element2).find("div.question").each(function (index, element) {
                    if (first_page) {
                        limit_page = 220;
                    } else {
                        limit_page = 90;
                    }
                    console.log((index + 1) + " - " + cur_height, $(element).height());
                    cur_height += $(element).height();
                    if (cur_height > page_height - limit_page) {
                        console.log((index2 + 1) + " - " + (index + 1) + " - " + cur_height + " - Overflow! Limit: " + limit_page);
                        $(element2).find("page").removeClass("page-new");
                        $(element2).append("<page " + page_attr + " class='page-new'>" + $(element2).find(".header_other").html() + "<div style='height: 20px;'></div><cart-viewer><div class='cart-one' " + cart_attr + "></div></cart-viewer></page>");
                        cur_page++;
                        cur_height = $(element).height();
                        first_page = false;
                    }
                    if ($(element2).find("page").hasClass("page-new")) {
                        $(element2).find("page.page-new div.cart-one").append("<div class='question'>" + $(element).html() + "</div>");
                        $(element).closest("div.question").remove();
                    }
                });
                while (cur_page < 4) {
                    $(element2).append("<page " + page_attr + "></page>");
                    cur_page++;
                }
                if (cur_page % 2 != 0) {
                    $(element2).append("<page " + page_attr + "></page>");
                    cur_page++;
                }
                if (cur_page == 6 || cur_page == 10) {
                    $(element2).append("<page " + page_attr + "></page><page " + page_attr + "></page>");
                    cur_page += 2;
                }
                
                if ($(element2).find("div.question").length > 1) {
                    $(element2).find(".num-trang").html(formatZero($(element2).find("page").length) + " trang");
                    $(element2).find(".num-cau").html(formatZero($(element2).find("div.question").length - 1) + " câu hỏi");
                    $(element2).find(".num-diem").html(formatNumber(10 / ($(element2).find("div.question").length - 1)) + " điểm");
                }
            });

        });

        $("#toggle-scroll").click(function () {
            if($(this).hasClass("active")) {
                $("body, html").scrollTop(0);
                $(this).removeClass("active").html("Cuộn xuống");
            } else {
                $("body, html").scrollTop($("body, html").height());
                $(this).addClass("active").html("Cuộn lên");
            }
        });
    }, 1000);
}

function formatZero(number) {
    if (number < 10) {
        return "0" + number;
    } else {
        return number;
    }
}

function formatNumber(number) {
    var number = parseFloat((number * 100) / 100).toFixed(3);
    if (parseInt(number.substring(5, 4)) == "0") {
        return number.substring(0, 4);
    } else {
        return number;
    }
}

function getAttr(obj) {
    var attrs = '';
    $(obj).each(function() {
        $.each(this.attributes, function() {
            if(this.specified) {
                if (this.name == 'class' || this.name == 'id') {
                } else {
                    if (this.value != '') {
                        attrs += ' ' + this.name + '="' + this.value + '"'; 
                    } else {
                        attrs += ' ' + this.name;
                    }
                }
            }
        });
    });
    return attrs;
}